import pr from 'post-robot'
window.postRobot = pr
export * from './main'
